export default "__VITE_ASSET__WGziy6sH__"